import Vue from 'vue'
import Router from 'vue-router'

// const Login = () => import('../login')

const AppMain = () => import('../AppMain')

Vue.use(Router)

const router = new Router({
//   mode: 'history',  //去掉url中的#
  routes: [
    {
      path:'*',
      redirect:'/404',
      component:AppMain,
      meta:{title:'404'},
      children:[
        {path: '/404',component: () => import('../views/notfound')},
      ]
    },
    {
      path: '/',
      redirect:'/index',
      component:AppMain,//顶部导航栏，底部信息栏
      children:[
        { path: '/index',component: () => import('../views/index') },
        { path: '/search',meta:{title:'搜索'},component: () => import('../views/search') },
        { path: '/search/detail/:type/:id',meta:{title:'搜索详情'},component: () => import('../views/newsDetail') },
        {
          // 人大概况
          path: '/rdgk',
          redirect:'/rdgk/zrzc',
          component:() => import('../views/rdgk/rdgkMenu'),//人大概况菜单栏
          children:[
            {path: 'zrzc',meta:{title:'主任之窗'},component: () => import('../views/rdgk/zrzc')},
            {path: 'cwhdz',meta:{title:'常委会党组'},component: () => import('../views/rdgk/zrzcProvince')},
            {path: 'cwhzcry',meta:{title:'常委会组成人员'},component: () => import('../views/rdgk/cwhzcry')},
            {path: 'rddb',meta:{title:'人大代表'},component: () => import('../views/rdgk/rddb')},
            {path: 'archives/:id',meta:{title:'代表档案'},component: () => import('../views/rdgk/archives')},
            {path: 'jgsz',meta:{title:'机构设置'},component: () => import('../views/rdgk/jgsz')},
          ]
        },
        //无需人大概况菜单栏组件
        { path: '/rdgk/detail/:id',meta:{title:'人物介绍'},component: () => import('../views/rdgk/cwhdetail') },
        //人大概况，机构设置
        { path: '/rdgk/newsdetail/:id',meta:{title:'机构设置详情'},component: () => import('../views/newsDetail') },
        {
          // 工作动态
          path: '/gzdt',
          redirect:'/gzdt/list',
          component:() => import('../views/gzdt/gzdtMenu'),
          children:[
            {path: 'list',meta:{title:'工作动态'},component: () => import('../views/gzdt/index')},
            {path: 'xzpd',meta:{title:'乡镇频道'},component: () => import('../views/gzdt/index')},
            {path: 'jyjd',meta:{title:'决议决定'},component: () => import('../views/gzdt/index')},
            {path: 'jdpy',meta:{title:'监督评议'},component: () => import('../views/gzdt/index')},
            {path: 'xjrm',meta:{title:'选举任免'},component: () => import('../views/gzdt/index')},
            {path: 'dbgz',meta:{title:'代表工作'},component: () => import('../views/gzdt/index')},
            {path: 'jgjs',meta:{title:'机关建设'},component: () => import('../views/gzdt/index')},
            {path: 'gsgg',meta:{title:'公示公告'},component: () => import('../views/gzdt/index')},
            // {path: 'ztzl',component: () => import('../views/gzdt/index')},
          ]
        },
        { path: '/gzdt/detail/:type/:id',meta:{title:'工作动态详情'},component: () => import('../views/newsDetail') },
        {
          // 会议专题
          path: '/hyzt',
          redirect:'/hyzt/dbdh',
          component:() => import('../views/hyzt/hyztMenu'),
          children:[
            {path: 'dbdh',meta:{title:'代表大会'},component: () => import('../views/hyzt/index')},
            {path: 'cwhy',meta:{title:'常委会议'},component: () => import('../views/hyzt/index')},
            {path: 'zrhy',meta:{title:'主任会议'},component: () => import('../views/hyzt/index')},
          ]
        },
        { path: '/hyzt/detail/:type/:id',meta:{title:'会议专题详情'},component: () => import('../views/newsDetail') },
        // {
        //   // 互动交流
        //   path: '/hdjl',
        //   redirect:'/hdjl/dczj',
        //   component:() => import('../views/hdjl/hdjlMenu'),
        //   children:[
        //     {path: 'dczj',component: () => import('../views/hdjl/index')},
        //     {path: 'zxjy',component: () => import('../views/hdjl/index')},
        //     {path: 'jbts',component: () => import('../views/hdjl/index')},
        //   ]
        // },
        // {
        //   // 党史学习
        //   path: '/dsxx',
        //   redirect:'/dsxx/ywjj',
        //   component:() => import('../views/dsxx/dsxxMenu'),
        //   children:[
        //     {path: 'ywjj',meta:{title:'要问聚焦'},component: () => import('../views/dsxx/index')},
        //     {path: 'llpl',meta:{title:'理论评论'},component: () => import('../views/dsxx/index')},
        //     {path: 'xxdt',meta:{title:'学习动态'},component: () => import('../views/dsxx/index')},
        //   ]
        // },
        // { path: '/dsxx/detail/:type/:id',meta:{title:'党史学习详情'},component: () => import('../views/newsDetail') },

      ]
    },
    
    

  ]
})

export default router

router.beforeEach((to, from, next) => {
  // 加载新页面，回到顶部
  // document.getElementById('app').scrollTop = 0; // 对于大多数浏览器
  next();
});

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

